module.exports = __webpack_public_path__ + "static/media/1POLICY33.9d67d24d.jpg";